/**
 * @Author: v_jppjpeng
 * @Date: 2022-10-28 16:26:41
 * @Explain: 正则
 */

/** 常规 */
export const pattern = {
  /** 验证邮箱 例如：abc@tencent.com */
  email: /(@([0-9a-zA-Z\-]+\.)+[0-9a-zA-Z]{2,})$/,
  /** 邮箱格式校验 */
  emailCheck:
    /^(?:(?:(?:(?:[a-zA-Z0-9]|[!#$%&'*+\-/=?^_`{|}~]|[^\u0000-\u007F])+(?:\.([a-zA-Z0-9]|[!#$%&'*+\-/=?^_`{|}~]|[^\u0000-\u007F])+)*)|(?:(?:")(?:(?:(?:(?:\s|\t)*(?:\r\n|\n|\r))?(\s|\t)+)?(?:(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x7F]|\x21|[^\u0000-\u007F])|(?:[\x01-\x09\x0B\x0C\x0D-\x7F]|[^\u0000-\u007F])))*(?:(?:(?:\s|\t)*(?:\r\n|\n|\r))?(\s|\t)+)?(?:"))))@(?:(?:(?:[a-zA-Z0-9]|[^\u0000-\u007F])|(?:(?:[a-zA-Z0-9]|[^\u0000-\u007F])(?:[a-zA-Z0-9]|-|\.|~|[^\u0000-\u007F])*(?:[a-zA-Z0-9]|[^\u0000-\u007F])))\.)+(?:(?:[a-zA-Z]|[^\u0000-\u007F])|(?:(?:[a-zA-Z]|[^\u0000-\u007F])(?:[a-zA-Z0-9]|-|\.|~|[^\u0000-\u007F])*(?:[a-zA-Z]|[^\u0000-\u007F])))\.?$/,
  /** WhatsApp格式校验 */
  whatsAppCheck: /^(\+?\d{4,15})$/,
  /** 匹配图片URL地址*/
  getImgUrl: /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)(png|jpg|jpeg)/g,
  /** 匹配图片URL地址*/
  getEmailTemplateImgUrl:
    /(http:\/\/|https:\/\/)((\w|=|\?|\.|\x20|\/|&|-)+)(png|jpg|jpeg|gif|bmp|tif|tiff)/g,
  // 验证是数字 (包含正负数，不包含小数)
  numberConcatNegative: /^(0|[1-9][0-9]*|-[1-9][0-9]*)$/,
  // 验证是数字 (包含正负数、小数)
  isNumberRule: /^[-+]?\d+(?:\.\d+)?$/,
  // 校验字符串是否为数值(包含小数与负数)
  isNumberConcatNegativeFloat: /^(?:-)?\d+(?:\.\d+)?$/,
  // 验证是带有科学计数法的整数
  eInteger: /^-?\d+(\.\d+)?[eE][-+]?\d+$/,
  // 验证字符串是科学计数法表示的正数（不包括负数、小数），但允许正号（+）
  ePositiveInteger: /^\+?\d+\.?\d*[Ee]\+?\d+$/,
  // 验证img标签src属性是否有值
  imgSrc: /<img[^>]+src=['"]([^'"]+)['"]+/gi,
  // 剔除标签
  dropHtmlTag: /(<([^>]+)>)/gi,
  // 含加号
  plusSign: /([+])0/g,
  // 含减号
  withMinusSign: /([+-])0/g,
  // 验证是数字
  isNumber: /^[0-9]*$/,
  // 校验前后空格或全部空格
  isSpace: /^\S.*\S$|(^\S{0,1}\S$)/,
  // 正整数
  isInt: /^[0-9]\d*$/,
  // 验证是数字 (包含正负数、小数)
  checkNumber: /^[-+]?\d+(?:\.\d+)?$/,
  // 验证0~100的整数
  withinOneHundred: /^(100|[1-9]?[0-9])$/,
  // 验证字符串是否仅包含数字和字母
  isAlphanumeric: /^[a-zA-Z0-9]+$/,
};

/** 登录、注册、忘记密码 */
export const adminPattern = {
  /** 支持字母、数字、下划线等特殊字符，不支持空格，字母区分大小写 */
  userName: /^[\w!@#$%^&*()\-+=<>?/\[\]{}|`~:;"',.]{1,100}$/,
  /** 用户密码 最少8个字符，至少一个大写字母，一个小写字母，一个数字和一个特殊字符 */
  userPassword:
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_+=<>?/\[\]{}|`~:;"',.]).{8,}$/,
  /** 至少一个小写字母 */
  userPassword_1: /(?=.*?[a-z])/,
  /** 至少一个大写字母 */
  userPassword_2: /(?=.*?[A-Z])/,
  /** 至少一个数字 */
  userPassword_3: /(?=.*?[0-9])/,
  /** 至少一个特殊字符 */
  userPassword_4: /(?=.*[!@#$%^&*()\-_+=<>?/\[\]{}|`~:;"',.])/,
  /** 最少8个字符 */
  userPassword_5: /.{8,}/,
};

/** 业务逻辑规则 */
export const businessPattern = {
  // domainName: /^(?!.*--.*)[a-zA-Z0-9][a-zA-Z0-9-]{1,100}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
  /** 验证域名 例如：abc.com */
  domainName: /^[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9](?:\.[a-zA-Z]{2,})+$/,
  /** 验证以api-开头 */
  isApi: /^(API-)/i,
  /** 验证以API-LI开头 */
  isApiLi: /^(API-LI)/,
  /** 占位符名称 支持英文字母、数字、短横线、下划线，且严格区分大小写， 最大长度100 */
  placeholderNameReg: /^[a-zA-Z0-9_-]{1,100}$/,
  /** 验证发件地址 只能输入 数字、字母、下划线、短横线 */
  emailPrefixReg: /^[a-zA-Z0-9_\\-]*$/,
  /** 验证中英文逗号
   * \u002C 代表英文逗号
   * \uFF0C 代表中文逗号 132|456   123|789
   */
  zhAndEnCommas: /[\u002C\uFF0C]/,
  /** 验证中英文分号
   * \u003B 代表英文分号
   * \uFF1B 代表中文分号
   */
  zhAndEnSemicolon: /[\u003B\uFF1B]/,
  /** 验证竖线
   * \u007C 代表竖线（|）
   */
  verticalLine: /[\u007C]/,
  // 校验表情符号
  emoji:
    /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F1E0}-\u{1F1FF}]/u,
  /**
   * 英文字母 数字 下划线组成，字母开头 正则表达式
   * 例如 a_123
   * */
  validNamePattern: /^[A-Za-z][A-Za-z0-9_]*$/,
};

/** 时间正则 */
export const datePattern = {
  /** 验证日期格式 eg: 2012-01-05+01:30、 2012-01-05-01:30 */
  contactsDate_1:
    /((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29))(([+-]([0][0-9]|1[0-2]):[00|30])|(([+])(1[3-4]):[00]))\d$/,
  /** 验证日期格式+时区 eg: 2012-01-05 01:15:36+01:30、 2012-01-05 01:15:36-01:30*/
  contactsDate_2:
    /((([0-9]{3}[1-9]|[0-9]{2}[1-9][0-9]{1}|[0-9]{1}[1-9][0-9]{2}|[1-9][0-9]{3})-(((0[13578]|1[02])-(0[1-9]|[12][0-9]|3[01]))|((0[469]|11)-(0[1-9]|[12][0-9]|30))|(02-(0[1-9]|[1][0-9]|2[0-8]))))|((([0-9]{2})(0[48]|[2468][048]|[13579][26])|((0[48]|[2468][048]|[3579][26])00))-02-29))\s([0-1][0-9]|2[0-3]):([0-5][0-9]):([0-5][0-9])(([+-]([0][0-9]|1[0-2]):[00|30])|(([+])(1[3-4]):[00]))\d$/,
  /** 匹配 时区 eg: 2012-01-05+01:30 2012-01-05 01:15:36+01:30 匹配出 +01:30*/
  matchTimezone: /([+-]\d{2}:\d{2})$/,
  /** ISO 8601 时间格式 2024-08-06T14:28:50.026634+08:00 或 2024-08-06T14:28:50+08:00 */
  iso8601DateTime:
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:[+-]\d{2}:\d{2})?$/,
  /** 验证 2023-08-13 */
  yearMonthDay: /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/,
  /** 验证 2023-08-13 12:12:12  */
  yearMonthDayTime: /^[0-9]{4}-[0-9]{2}-[0-9]{2}\s[0-9]{2}:[0-9]{2}:[0-9]{2}$/,
};

// csv导入联系人
export const contactFromCsv = {
  /** 验证 | ; */
  split: /\||;/,
  /** 验证字符串带有英文;号 */
  isSemicolon: /;/,
  /** 验证字符串带有管道符|号 */
  isPipeSymbol: /\|/,
};

export const onPattern = (value: any, reg: RegExp) => reg.test(value);
